// extracted by mini-css-extract-plugin
export default {"body":"useNotify_body__+DiVC","button":"useNotify_button__gw5H+"};